import { useMemo } from "react";
import { useStore } from "../store/store.hooks.js";
import { useInput } from "../util/util.hooks.js";
export function useForm(formOrId) {
    const store = useStore();
    const defaultValues = useMemo(() => {
        if (typeof formOrId === "string") {
            return {};
        }
        const data = {};
        for (let i = 0; i < formOrId.fields.length; i++) {
            const field = formOrId.fields[i];
            if (field.defaultValue) {
                data[field.name] = field.defaultValue;
            }
        }
        return { ...data, ...store.context.query };
    }, [formOrId, store.context.query]);
    const url = `/api/v1/front/forms/${typeof formOrId === "string" ? formOrId : formOrId._id}/entries`;
    const inputHandler = useInput({
        method: "POST",
        url,
        initialInput: defaultValues,
    });
    return inputHandler;
}
